import { createSlice } from '@reduxjs/toolkit';
import { isBannedShareScreen, isEnableBanAllShareScreen } from './functions';
import { getConferenceState } from '../base/conference/functions';
import { getParticipantById, isParticipantModerator } from '../base/participants/functions';
import ReducerRegistry from '../base/redux/ReducerRegistry';
export const approveParticipantShareScreen = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (!participant) {
        return;
    }
    const isBanned = isBannedShareScreen(participant, state);
    if (isBanned) {
        conference?.shareScreenModerationApprove(id);
    }
};
export const rejectParticipantShareScreen = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (!participant) {
        return;
    }
    const isBanned = isBannedShareScreen(participant, state);
    const isModerator = isParticipantModerator(participant);
    if (!isBanned && !isModerator) {
        conference?.shareScreenModerationReject(id);
    }
};
export const enableBanAllShareScreen = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAllShareScreen(state);
    if (!isBanAll) {
        conference?.enableShareScreenModeration();
    }
};
export const disableBanAllShareScreen = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAllShareScreen(state);
    if (isBanAll) {
        conference?.disableShareScreenModeration();
    }
};
const initialState = {
    enabled: false,
    whitelist: {},
    blacklist: {},
    canShareScreen: undefined,
    actor: null,
};
const shareScreenModeration = createSlice({
    name: 'features/shareScreen-moderation',
    initialState,
    reducers: {
        disableShareScreenModeration: (state, action) => {
            if (state.enabled) {
                state.enabled = false;
                state.actor = action.payload;
                state.canShareScreen = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        enableShareScreenModeration: (state, action) => {
            if (!state.enabled) {
                state.enabled = true;
                state.actor = action.payload;
                state.canShareScreen = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        localParticipantApproved: (state) => {
            state.canShareScreen = true;
        },
        localParticipantRejected: (state) => {
            state.canShareScreen = false;
        },
        participantApproved: (state, action) => {
            if (state.enabled) {
                state.whitelist[action.payload.jid] = true;
            }
            else {
                state.blacklist[action.payload.jid] = false;
            }
        },
        participantRejected: (state, action) => {
            if (state.enabled) {
                state.whitelist[action.payload.jid] = false;
            }
            else {
                state.blacklist[action.payload.jid] = true;
            }
        },
        onShareScreenWheel: (state, action) => {
            const wheelEvent = action.payload;
            const wheelMouseEvent = action.payload;
            if (wheelEvent) {
                state.wheelEvent = {
                    offsetX: wheelMouseEvent.offsetX,
                    offsetY: wheelMouseEvent.offsetY,
                    deltaX: wheelEvent.deltaX,
                    deltaY: wheelEvent.deltaY
                };
            }
        }
    }
});
ReducerRegistry.register('features/shareScreen-moderation', shareScreenModeration.reducer);
export const { disableShareScreenModeration, enableShareScreenModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected, onShareScreenWheel } = shareScreenModeration.actions;
export default shareScreenModeration.reducer;
